import { render, staticRenderFns } from "./SelectedProducts.vue?vue&type=template&id=80b7482a&scoped=true"
import script from "./SelectedProducts.vue?vue&type=script&lang=js"
export * from "./SelectedProducts.vue?vue&type=script&lang=js"
import style0 from "./SelectedProducts.vue?vue&type=style&index=0&id=80b7482a&prod&lang=scss&scoped=true"
import style1 from "./SelectedProducts.vue?vue&type=style&index=1&id=80b7482a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b7482a",
  null
  
)

export default component.exports